import DynamicForm from './components/form/Form';
import './App.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { useContext, useEffect } from 'react';
// import { AuthContext } from './context/auth-context';
// import getToken from './store/auth';
import lang from './localization/localization';

function App() {
  // const { token, setToken } = useContext(AuthContext);
  const language = localStorage.getItem('lang');
  const baseUrl = localStorage.getItem('baseUrl');
  const linkedCalc = localStorage.getItem('currentCalc');
  lang.setLanguage(language);

  console.log('app loaded', baseUrl, linkedCalc)

  const CAR_LOAN_CORE_INPUTS = {
    coreInput1: 'auto_car_condition',
    coreInput2: 'auto_programs_new',
    coreInput3: 'auto_programs_used'
  };

  const CASH_LOAN_CORE_INPUTS = {
    coreInput1: 'cash_programs',
  }

  const MORTGAGE_LOAN_CORE_INPUTS = {
    coreInput1: 'mortgage_programs',
  }

  // useEffect(() => {
  //   updateToken();
  // }, []);

  // const updateToken = async () => {
  //   const token = await getToken();
  //   const hasToke = localStorage.getItem('token');
  //   if (hasToke) {
  //     setToken(hasToke);
  //   }
  // }


  return (
    <>
      {
        linkedCalc === '1' ? <DynamicForm info={{
          getApi: `${baseUrl}/auto/main/calculator/form?lang=${language}`,
          postApi: `${baseUrl}/auto/main/calculator/submit?lang=${language}`,
          coreInputs: CAR_LOAN_CORE_INPUTS,
          title: lang.carLoan,
          icon: '<span class="icon-car calculators-icon"></span>'
        }}

        /> : linkedCalc === '2' ? <DynamicForm info={{
          getApi: `${baseUrl}/cash/main/calculator/form?lang=${language}`,
          postApi: `${baseUrl}/cash/main/calculator/submit?lang=${language}`,
          coreInputs: CASH_LOAN_CORE_INPUTS,
          title: lang.cacheLoan,
          icon: '<span class="icon-wallet calculators-icon"></span>'
        }}
        /> : linkedCalc === '3' ? <DynamicForm info={{
          getApi: `${baseUrl}/mortgage/main/calculator/form?lang=${language}`,
          postApi: `${baseUrl}/mortgage/main/calculator/submit?lang=${language}`,
          coreInputs: MORTGAGE_LOAN_CORE_INPUTS,
          title: lang.mortgageLoan,
          icon: '<span class="icon-home calculators-icon"></span>'
        }}

        /> : null
      }
    </>
  );
}

export default App;
